export function formatChatTime(timestamp: number | string | Date): string {
  let date: Date;
  if (typeof timestamp === 'number') date = new Date(timestamp);
  else if (typeof timestamp === 'string') date = new Date(timestamp);
  else date = timestamp;
  if (isNaN(date.getTime())) return '--:--';

  const now = new Date();
  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  if (isToday) {
    return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  }
  return `${date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' })} ${
    date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
  }`;
}

export function isEmojiOnlyMessage(text: string): boolean {
  if (!text) return false;

  const emojiRegex = /(?:\p{Emoji_Presentation}|\p{Emoji}\uFE0F)(?:\u200D(?:\p{Emoji_Presentation}|\p{Emoji}\uFE0F))*/gu;
  const trimmed = text.replace(/\s/g, '');
  const emojis = trimmed.match(emojiRegex);

  if (!emojis || emojis.length === 0 || emojis.length > 3) {
    return false;
  }

  return emojis.join('') === trimmed;
}

export function getGlobalMessageId(
  msg: { messageId?: string; timestamp: number; pseudo: string },
): string {
  return msg.messageId || `${msg.timestamp}-${msg.pseudo}`;
}
